import $ from 'jquery';
import slider from '../slider/c-slider';

// default slider has no changes to the config
if ($('.default-slider').length > 0) {
    slider('default-slider');
}

// Style guide exmaple sliders
if ($('.eg-image-slider').length > 0 || $('.eg-generic-slider').length > 0) {
    // Accordion on click is only here because the Styleguide content is buried in an accordion. if we just initialise the sliders, because the accordion content is display: none, all the widths are busted. So wait until everything is visible to initialise them.
    $('.accordion-heading').on('click', () => {
        // Create the slider
        setTimeout(() => {
            slider('eg-image-slider');

            const tileSliderOpts = {
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3
            };

            slider('eg-generic-slider', tileSliderOpts);
        }, 300);
    });
}

if ($('.center-slider .c-base-tile').length > 3) {
    // Create the slider

    const centerSliderOpts = {
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                    arrows: true
                }
            }
        ],
        speed: 400,
        useTransform: true,
        cssEase: 'ease-in-out',
        arrows: false
    };

    slider('center-slider', centerSliderOpts);
}

if ($('.quote-slider .c-bg-tile').length > 1) {
    // Create the slider

    const quoteSliderOpts = {
        slidesToShow: 1,
        infinite: true,
        speed: 800,
        useTransform: true,
        cssEase: 'ease-in-out',
        dots: false,
        autoplay: true
    };

    slider('quote-slider', quoteSliderOpts);
}
